import { useFormContext } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { REQUIRED_VALIDATION } from 'constants/validation-rules.constants';
import { CorrectionInput } from 'interfaces/corrections.interfaces';
import { Card } from 'shared-components/Card';
import { Textarea } from 'shared-components/Textarea';

export const CorrectionAnalysisFields = () => {
  const { formatMessage } = useIntl();

  const {
    register,
    formState: { errors },
  } = useFormContext<CorrectionInput>();

  return (
    <Card title='results' wrapperClassName='flex-1 overflow-visible' className='flex flex-col gap-6'>
      <Textarea
        {...register('results', REQUIRED_VALIDATION)}
        isRequired
        label='results'
        error={errors['results']?.message}
        placeholder={formatMessage({ id: 'results' })}
        data-test='correction-results'
        rows={4}
      />
    </Card>
  );
};
